import { TimelineSection } from '../section-listing.model';

export class ObservationSection extends TimelineSection {
  observationType: string;
  observationDescription: string;
}
